<template>
  <div class="row">
    <h1 class="small-12 columns">Add New Tag</h1>
    <div class="small-3 columns">Name</div>
    <div class="small-9 columns">
      <input v-model="name" type="text" class="input-box-course-creators" />
    </div>
    <button class="button-green" @click="addNewTag">Add New Tag</button>
    <div>
      <VModal
        name="duplicate_tag"
        :click-to-close="true"
        width="220px"
        height="150px"
        style="position: relative;"
      >
        <div style="position: absolute; top: 5px; right: 5px;">
          <button @click="$modal.hide('duplicate_tag')">
            X
          </button>
        </div>
        <div
          style="width: 100%; height: 100%;"
          class="text-center flex justify-center items-center"
        >
          Tag Name already in use!
        </div>
      </VModal>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      name: "",
    }
  },
  methods: {
    addNewTag() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}qtags/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: this.name, attachments: "" },
      }).then(res => {
        if (!res.data.id) {
          this.$modal.show("duplicate_tag")
        } else {
          this.$router.push("/tags/")
        }
      })
    },
  },
}
</script>
